import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  .period-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: ${({ theme }) => theme.colors.lighterBackground};
    border: 2px solid ${({ theme }) => theme.colors.gray[100]};
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    flex: 1;
    justify-content: center;

    img {
      width: 20px;
      height: 20px;
    }

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary.main};
      background: ${({ theme }) => theme.colors.primary.main};
      color: ${({ theme }) => theme.colors.lighterBackground};
    }
  }

  .clear-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: ${({ theme }) => theme.colors.danger.main};
    border: none;
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.lighterBackground};
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease-in;

    &:hover {
      opacity: 0.8;
    }
  }
`;
